import { DEFAULT_CHANNELS } from '../../main/constants/audio.ts';
import { DEFAULT_SAMPLE_RATE } from '../../main/constants/audio.ts';

import { SpeechSuperSdkParams, SpeechSuperAudioParams } from '../types/speechsuper-request.types.ts';

export enum SpeechSuperCoreTypeEnum {
  WORD = 'word.eval.promax',
  SENTENCE = 'sent.eval.promax',
}

export enum SpeechSuperDictTypeEnum {
  CMU = 'CMU',
  KK = 'KK',
  IPA88 = 'IPA88',
}

export enum SpeechSuperDictDialectEnum {
  AMERICAN = 'en_us',
}

export enum SpeechSuperAgeGroupEnum {
  PRE_SCHOOL = 1, // 3-6 years old
  ELEMENTARY = 2, // 6-12 years old
  MIDDLE_SCHOOL = 3, // 12+ years old
}

export enum SpeechSuperReadTypeEnum {
  NORMAL = 0,
  INSERTION_BEFORE = 1,
  INSERTION_AFTER = 2,
  NOT_PRONOUNCED = 3,
  REPEATED = 4,
  MISPRONOUNCED = 6,
}

export enum SpeechSuperStressEnum {
  UNSTRESSED = 0,
  PRIMARY = 1,
  SECONDARY = 2,
}

export enum SpeechSuperCharTypeEnum {
  CURRENT_LANGUAGE = 0,
  OTHER_LANGUAGE = 1,
}

export enum SpeechSuperEofEnum {
  ZERO = 0,
  ONE = 1,
}

export enum SpeechSuperBooleanEnum {
  FALSE = 0,
  TRUE = 1,
}

export enum SpeechSuperCommandEnum {
  CONNECT = 'connect',
  START = 'start',
  STOP = 'stop',
}

export const EVALUATION_TIMEOUT = 5000; // 5 seconds
export const BACKUP_EVALUATION_DELAY = 2000; // 2 seconds
export const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes in milliseconds
export const PENDING_REQUEST_TIMEOUT = 30 * 1000; // 30 seconds

export const SPEECH_SUPER_SDK: SpeechSuperSdkParams = {
  version: 16777472,
  source: 4,
  protocol: 1,
} as const;

export const SPEECH_SUPER_DEFAULTS = {
  GET_PARAM: 1,
  DICT_TYPE: SpeechSuperDictTypeEnum.IPA88,
  PHONEME_OUTPUT: 1,
  SCALE: 100,
  PRECISION: 1,
  SLACK: 0,
  AGE_GROUP: SpeechSuperAgeGroupEnum.MIDDLE_SCHOOL,
} as const;

export const SPEECH_SUPER_DEFAULT_AUDIO_PARAMS: SpeechSuperAudioParams = {
  audioType: 'wav',
  channel: DEFAULT_CHANNELS,
  sampleBytes: 2,
  sampleRate: DEFAULT_SAMPLE_RATE,
} as const;

export const SPEECH_SUPER_CONNECTION_MANAGER_OPTIONS = {
  MAX_IDLE_TIME: 60 * 1000, // 1 minute
  MAX_CONNECTION_AGE: 30 * 1000, // 30 seconds
  VERIFY_CONNECTION_INTERVAL: 15 * 1000, // 15 seconds
} as const;
